import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { getSettings } from "../../../common/settingsProvider";
import { downloadFile } from "../../../common/api/downloadFile";
import { createPdfUrl } from "../../../common/pdfUrlHelper";
import { post } from "../../../common/api/apiShared";
import { useUrlProvider } from "../../../useUrlProvider";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";
import { useTranslation } from "@localization/useTranslation";
import { IRiskManagementReportDialogProps } from "./RiskManagementReportDialog";
import { RiskManagementReportDownloadModel } from "./RiskManagementReportDialog.types";

export default function useRiskManagementReportDialogHooks(props: IRiskManagementReportDialogProps) {
    const { translateString } = useTranslation();
    const { getRiskManagementReportPdfUrl } = useUrlProvider();
    const snackBar = useDotLegalSnackbar();
    const { language } = useUserContext();

    const [saveModel, setSaveModel] = useState<RiskManagementReportDownloadModel>({ note: "" });
    const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);

    const saveMutation = useDotLegalMutation(save, {
        onSuccess: async (response: any) => {
            await downloadPdf(response.value().id);
        },
    });

    function save() {
        return post<string>("/risk-management-report-downloads/", saveModel);
    }

    async function downloadPdf(id: string) {
        const fileName = translateString("riskManagementReportFileName");
        const queryUrl = getRiskManagementReportPdfUrl(id);

        await downloadFile(getSettings().apiBaseUrl + "/pdf/generate?noMargin=true&url=" + createPdfUrl(queryUrl, language), `${fileName}.pdf`).then(() => {
            snackBar.show(createElement(Trans, { i18nKey: "pdfDownloadComplete", values: { fileName } }));
            setIsDownloadingPdf(false);
            props.onDialogClose();
        });
    }

    const onNoteChange = (note: string) => {
        setSaveModel({ ...saveModel, note });
    };

    const onDownloadPdfClick = async () => {
        setIsDownloadingPdf(true);
        await saveMutation.mutateAsync();
    };

    return { saveModel, onNoteChange, onDownloadPdfClick, isDownloadingPdf };
}
